exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#systemDetailsRetirever-wrapper .padding {\r\n            margin-bottom: 5%;\r\n        }\r\n\r\n#systemDetailsRetirever-wrapper .color:hover {\r\n            background-color: #007eed;\r\n        }\r\n\r\n#systemDetailsRetirever-wrapper .color:active {\r\n            background-color: #0084b4;\r\n        }", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/css-loader!F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemDetailsRetriever/system-details-retriever.component.css
 ** module id = 945
 ** module chunks = 2
 **/